import { lazy } from "react";
import { RegisterBookings } from "../landing/RegisterBookings";
import { URL_BOOKINGS } from "../../../utils/urls";
import OtpVerification from "./OtpVerification";
import ChangePassword from "./ChangePassword";

const Login = lazy(() => import("./LoginPage"));
const RegisterPage = lazy(() => import("./RegisterPage"));
const Landing = lazy(() => import("../landing/Landing"));
const ResetPassword = lazy(() => import("./ResetPassword"));
const ForgotPassword = lazy(() => import("./ForgotPassword"));

const AuthRoutes = [
  {
    path: "/",
    component: <Landing />,
    exact: true,
  },
  {
    path: "/login",
    component: <Login />,
    exact: true,
  },
  {
    path: "/register",
    component: <RegisterPage />,
    exact: true,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
    exact: true,
  },
  {
    path: "/change-password",
    component: <ChangePassword />,
    exact: true,
  },
  {
    path: "/otp-verification",
    component: <OtpVerification />,
    exact: true,
  },
  {
    path: "/password-reset/:token",
    component: <ResetPassword />,
    exact: true,
  },

  {
    path: `${URL_BOOKINGS}/create`,
    component: <RegisterBookings />,
    exact: true,
  },
];

export default AuthRoutes;
